/* app/js/src/components/mediaEditor/media-segments/media-segments.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.container {
  width: fit-content;
}
.container .header remove-button {
  transform: scale(1.29);
  padding-top: 3px;
  margin-left: 10px;
}
.container .body {
  margin-top: 15px;
}
.container .body table {
  min-width: 948.94px;
}
.container .body table thead tr {
  background-color: #dde3e7;
}
.container .body table thead tr th {
  text-align: left !important;
}
.container .body table tr:hover {
  background-color: #e7dfdf !important;
}
.container .body table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.container .body table th,
.container .body table td {
  text-align: center;
  padding: 3px 10px;
  font-size: 17px;
}
.container .body table th > div.complex,
.container .body table td > div.complex {
  display: flex;
  align-items: anchor-center;
  justify-content: center;
  gap: 10px;
}
.container .body table th > div.complex svg,
.container .body table td > div.complex svg {
  cursor: pointer;
  border: 1px solid #232f3a;
  border-radius: 4px;
  padding: 1px;
  scale: 1.5;
  margin: -2px 0;
}
.container .body table th > div.complex svg path,
.container .body table td > div.complex svg path {
  fill: #232f3a;
}
.container .body table .checkbox-field {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.container .body table .description-field {
  height: 30px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
}
.container .body table .description-field:focus {
  border: 1px solid #aee5ff !important;
  outline: none;
  transition: all 0.9s ease 0s !important;
}
.container .body table .rowSelectable {
  cursor: pointer;
}
.container .footer ichannel-button {
  margin-left: 15px;
}
/*# sourceMappingURL=media-segments.component.css.map */
